// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lease-end-wizard {
	width: 100%;
	max-width: 1400px;
	margin: 0 auto;
}

.lease-end-wizard .card-lg {
	width: 100%;
	min-height: 600px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.wizard-steps {
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;
	margin-bottom: 30px;
}

.wizard-step-item {
	flex: 1 1;
	position: relative;
}

.wizard-step {
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
	padding: 10px;
	text-decoration: none;
}

.step-number {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background-color: #e9ecef;
	color: #6c757d;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	margin-bottom: 8px;
	transition: all 0.3s ease;
}

.wizard-step.active .step-number {
	background-color: #007bff;
	color: white;
	transform: scale(1.1);
}

.wizard-step.completed .step-number {
	background-color: #28a745;
	color: white;
}

.step-title {
	font-size: 12px;
	text-align: center;
	color: #6c757d;
	font-weight: 500;
}

.wizard-step.active .step-title {
	color: #007bff;
	font-weight: 600;
}

.wizard-step.completed .step-title {
	color: #28a745;
}

.wizard-content {
	min-height: 400px;
	padding: 20px;
}

.wizard-navigation {
	border-top: 1px solid #dee2e6;
	padding-top: 20px;
	display: flex;
	justify-content: space-between;
}

/* Option Cards */
.option-card {
	border: 2px solid #dee2e6;
	border-radius: 8px;
	padding: 20px;
	margin-bottom: 15px;
	cursor: pointer;
	transition: all 0.3s ease;
}

.option-card:hover {
	border-color: #007bff;
	box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
}

.option-card.selected {
	border-color: #007bff;
	background-color: #e7f3ff;
}

.option-icon {
	font-size: 48px;
	margin-bottom: 15px;
}

/* Fee Summary */
.fee-summary-card {
	background-color: #f8f9fa;
	border: 1px solid #dee2e6;
	border-radius: 8px;
	padding: 20px;
	margin-top: 20px;
}

.fee-row {
	display: flex;
	justify-content: space-between;
	padding: 10px 0;
	border-bottom: 1px solid #dee2e6;
}

.fee-row:last-child {
	border-bottom: none;
	font-weight: bold;
	font-size: 1.2em;
	margin-top: 10px;
	padding-top: 15px;
	border-top: 2px solid #007bff;
}

.comparison-card {
	border: 2px solid #dee2e6;
	border-radius: 8px;
	padding: 20px;
	margin: 10px 0;
}

.comparison-card.recommended {
	border-color: #28a745;
	background-color: #f0fff4;
}

.recommended-badge {
	background-color: #28a745;
	color: white;
	padding: 5px 10px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: bold;
}

/* Damage List */
.damage-item {
	background-color: #fff;
	border: 1px solid #dee2e6;
	border-radius: 4px;
	padding: 15px;
	margin-bottom: 10px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.damage-item-info {
	flex: 1 1;
}

.damage-item-actions {
	display: flex;
	gap: 10px;
}

@media (max-width: 768px) {
	.wizard-steps {
		overflow-x: auto;
	}

	.step-title {
		font-size: 10px;
	}

	.step-number {
		width: 30px;
		height: 30px;
		font-size: 14px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/account/LeaseEnd/LeaseEndWizard.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,SAAO;CACP,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,6BAA6B;CAC7B,iBAAiB;CACjB,aAAa;CACb,8BAA8B;AAC/B;;AAEA,iBAAiB;AACjB;CACC,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,4CAA4C;AAC7C;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA,gBAAgB;AAChB;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;AAClB;;AAEA,gBAAgB;AAChB;CACC,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,SAAO;AACR;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,eAAe;CAChB;AACD","sourcesContent":[".lease-end-wizard {\n\twidth: 100%;\n\tmax-width: 1400px;\n\tmargin: 0 auto;\n}\n\n.lease-end-wizard .card-lg {\n\twidth: 100%;\n\tmin-height: 600px;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.wizard-steps {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.wizard-step-item {\n\tflex: 1;\n\tposition: relative;\n}\n\n.wizard-step {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tcursor: pointer;\n\tpadding: 10px;\n\ttext-decoration: none;\n}\n\n.step-number {\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 50%;\n\tbackground-color: #e9ecef;\n\tcolor: #6c757d;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tmargin-bottom: 8px;\n\ttransition: all 0.3s ease;\n}\n\n.wizard-step.active .step-number {\n\tbackground-color: #007bff;\n\tcolor: white;\n\ttransform: scale(1.1);\n}\n\n.wizard-step.completed .step-number {\n\tbackground-color: #28a745;\n\tcolor: white;\n}\n\n.step-title {\n\tfont-size: 12px;\n\ttext-align: center;\n\tcolor: #6c757d;\n\tfont-weight: 500;\n}\n\n.wizard-step.active .step-title {\n\tcolor: #007bff;\n\tfont-weight: 600;\n}\n\n.wizard-step.completed .step-title {\n\tcolor: #28a745;\n}\n\n.wizard-content {\n\tmin-height: 400px;\n\tpadding: 20px;\n}\n\n.wizard-navigation {\n\tborder-top: 1px solid #dee2e6;\n\tpadding-top: 20px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n/* Option Cards */\n.option-card {\n\tborder: 2px solid #dee2e6;\n\tborder-radius: 8px;\n\tpadding: 20px;\n\tmargin-bottom: 15px;\n\tcursor: pointer;\n\ttransition: all 0.3s ease;\n}\n\n.option-card:hover {\n\tborder-color: #007bff;\n\tbox-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);\n}\n\n.option-card.selected {\n\tborder-color: #007bff;\n\tbackground-color: #e7f3ff;\n}\n\n.option-icon {\n\tfont-size: 48px;\n\tmargin-bottom: 15px;\n}\n\n/* Fee Summary */\n.fee-summary-card {\n\tbackground-color: #f8f9fa;\n\tborder: 1px solid #dee2e6;\n\tborder-radius: 8px;\n\tpadding: 20px;\n\tmargin-top: 20px;\n}\n\n.fee-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 10px 0;\n\tborder-bottom: 1px solid #dee2e6;\n}\n\n.fee-row:last-child {\n\tborder-bottom: none;\n\tfont-weight: bold;\n\tfont-size: 1.2em;\n\tmargin-top: 10px;\n\tpadding-top: 15px;\n\tborder-top: 2px solid #007bff;\n}\n\n.comparison-card {\n\tborder: 2px solid #dee2e6;\n\tborder-radius: 8px;\n\tpadding: 20px;\n\tmargin: 10px 0;\n}\n\n.comparison-card.recommended {\n\tborder-color: #28a745;\n\tbackground-color: #f0fff4;\n}\n\n.recommended-badge {\n\tbackground-color: #28a745;\n\tcolor: white;\n\tpadding: 5px 10px;\n\tborder-radius: 4px;\n\tfont-size: 12px;\n\tfont-weight: bold;\n}\n\n/* Damage List */\n.damage-item {\n\tbackground-color: #fff;\n\tborder: 1px solid #dee2e6;\n\tborder-radius: 4px;\n\tpadding: 15px;\n\tmargin-bottom: 10px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.damage-item-info {\n\tflex: 1;\n}\n\n.damage-item-actions {\n\tdisplay: flex;\n\tgap: 10px;\n}\n\n@media (max-width: 768px) {\n\t.wizard-steps {\n\t\toverflow-x: auto;\n\t}\n\n\t.step-title {\n\t\tfont-size: 10px;\n\t}\n\n\t.step-number {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tfont-size: 14px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
